// extracted by mini-css-extract-plugin
module.exports = {"grid":"ProfileAccountView_grid__3BnIO","active":"ProfileAccountView_active__1oksX","container":"ProfileAccountView_container__t4bSb"};